export const leagues = [
  {
    id: 'nba',
    name: '美国职业篮球联赛',
    shortName: 'NBA',
    region: '北美',
    season: '2026-27',
    intro: '全球水平最高的职业篮球联赛，云集世界顶级球星，常规赛 82 场后进入季后赛争夺总冠军。',
    teamCount: 8,
    matchCount: 6,
  },
  {
    id: 'cba',
    name: '中国男子篮球职业联赛',
    shortName: 'CBA',
    region: '中国',
    season: '2026-27',
    intro: '中国最高级别的职业篮球联赛，汇聚国内顶尖球员与外援，赛程横跨全年，竞争激烈。',
    teamCount: 4,
    matchCount: 4,
  },
  {
    id: 'euro',
    name: '欧洲篮球联赛',
    shortName: 'EuroLeague',
    region: '欧洲',
    season: '2026-27',
    intro: '欧洲俱乐部篮球的顶级舞台，战术素养与团队配合出色，豪门对决观赏性十足。',
    teamCount: 4,
    matchCount: 3,
  },
  {
    id: 'wnba',
    name: '美国女子职业篮球联赛',
    shortName: 'WNBA',
    region: '北美',
    season: '2026',
    intro: '世界最高水平的女子职业篮球联赛，速度与技巧并重，近年来关注度持续攀升。',
    teamCount: 2,
    matchCount: 2,
  },
  {
    id: 'ncaa',
    name: '美国大学篮球联赛',
    shortName: 'NCAA',
    region: '北美',
    season: '2026-27',
    intro: '美国大学篮球赛事，是众多 NBA 新星的摇篮，疯狂三月更是全民关注的篮球盛宴。',
    teamCount: 2,
    matchCount: 2,
  },
  {
    id: 'fiba',
    name: '国际篮联国家队赛事',
    shortName: 'FIBA',
    region: '国际',
    season: '2026',
    intro: '由国际篮联主办的国家队级别赛事，代表各国篮球最高荣誉，全球球迷共同关注。',
    teamCount: 2,
    matchCount: 2,
  },
];